// import createPersistedState from 'vuex-persistedstate'

const documentDownloadsList = {
  // plugins: [createPersistedState({ key: 'lc-app' })], // LocalStorageに保存する場合はコメント解除
  namespaced: true,
  state: {
    mode: 'list', // モード(list: 一覧表示(ドリルダウン)モード、search: キーワード検索モード )
    packagesAndProductsAreaTreeData: {}, // パッケージ＆商品ツリーデータ
    packagesAndProductsAreaBooks: [], // 単体書籍リスト
    idMapListOfCheckedProducts: [], // チェックされている商品の商品IDと書籍IDのリスト（詳細から戻った時の復元用）
    selectedIdMapOfBooksArea: {} // 書籍エリアで選択されている商品ID(product_id)＆書籍ID(book_id)
  },
  getters: {
  },
  mutations: {
    clearAll(state) {
      state.mode = 'list'
      state.packagesAndProductsAreaTreeData = {}
      state.packagesAndProductsAreaBooks = []
      state.idMapListOfCheckedProducts = []
      state.selectedIdMapOfBooksArea = {}
    },
    setMode(state, mode) {
      state.mode = mode
    },
    setPackagesAndProductsAreaTreeData(state, packagesAndProductsAreaTreeData) {
      state.packagesAndProductsAreaTreeData = packagesAndProductsAreaTreeData
    },
    setPackagesAndProductsAreaBooks(state, packagesAndProductsAreaBooks) {
      state.packagesAndProductsAreaBooks = packagesAndProductsAreaBooks
    },
    setIdMapListOfCheckedProducts(state, idMapListOfCheckedProducts) {
      state.idMapListOfCheckedProducts = idMapListOfCheckedProducts
    },
    setSelectedIdMapOfBooksArea(state, selectedIdMapOfBooksArea) {
      state.selectedIdMapOfBooksArea = selectedIdMapOfBooksArea
    }
  },
  actions: {
    // 全ステートをクリア
    clearAll({ commit }) {
      commit('clearAll')
    },
    // モード
    setMode({ commit }, mode) {
      commit('setMode', mode)
    },
    // パッケージ＆商品ツリーデータ（詳細から戻った時の復元用）
    setPackagesAndProductsAreaTreeData({ commit }, packagesAndProductsAreaTreeData) {
      commit('setPackagesAndProductsAreaTreeData', packagesAndProductsAreaTreeData)
    },
    // 単体書籍リスト（詳細から戻った時の復元用）
    setPackagesAndProductsAreaBooks({ commit }, packagesAndProductsAreaBooks) {
      commit('setPackagesAndProductsAreaBooks', packagesAndProductsAreaBooks)
    },
    // チェックされている商品の商品IDと書籍IDのリスト（詳細から戻った時の復元用）
    setIdMapListOfCheckedProducts({ commit }, idMapListOfCheckedProducts) {
      commit('setIdMapListOfCheckedProducts', idMapListOfCheckedProducts)
    },
    // 書籍エリアで選択されている商品ID(product_id)＆書籍ID(book_id)
    setSelectedIdMapOfBooksArea({ commit }, selectedIdMapOfBooksArea) {
      commit('setSelectedIdMapOfBooksArea', selectedIdMapOfBooksArea)
    }
  }
}

export default documentDownloadsList
